import React from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ModalEnum } from '../../ModalEnum';
import { AppState } from '../../services/AppState';
import type { ReduxState } from '../../store';
import { openModal } from '../../store/app';
import { isSignedInSelector } from '../../store/selectors';
import Loader from '../Loader';

interface Props {
  children: React.ReactNode;
}

export default function Private(props: Props) {
  const dispatch = useDispatch();
  const { appState, isSignedIn } = useSelector((store: ReduxState) => ({
    appState: store.app.state,
    isSignedIn: isSignedInSelector(store),
  }));

  useEffect(() => {
    if (appState < AppState.LOADED) return;
    if (!isSignedIn) {
      dispatch(openModal(ModalEnum.SIGN_IN));
    }
  }, [appState, isSignedIn]);

  if (appState < AppState.LOADED) return <Loader />;
  if (!isSignedIn) return null;
  return <>{props.children}</>;
}
